import { gql } from '@apollo/client';

export const GET_MAPS_CONFIGURATION = gql`
  query GetMapsConfiguration($platform: MapsPlatformInput) {
    mapsConfiguration(platform: $platform)
  }
`;